export default (value) => {
  return permissionNames[value] ? permissionNames[value] : value
}

const permissionNames = {
  EMPLOYEE_MANAGEMENT: 'Employee Management',
  ADD_EDIT_EMPLOYEE_RECORD: 'Add and Edit Employee Records',
  VIEW_WAGE_DATA: 'View Wage Data',
  VIEW_EMPLOYEE_PASSWORD: 'View Employee Passwords',
  OVERRIDE_SCHEDULE_RESTRICTIONS: 'Override Schedule Restrictions',
  APPROVE_TIME_OFF_REQUESTS: 'Approve Time Off Requests',

  CASHIER_FUNCTIONS: 'Cashier Functions',
  USE_DISCOUNT_BUTTON: 'Use Discount Button',
  MAX_DISCOUNT_PCT: 'Max Discount Percentage',
  RECALL_OPEN_TICKET_NOT_ASSIGNED_TO_YOU: 'Recall Open Ticket Not Assigned to You',
  EDIT_SAVED_ITEMS_ON_AN_OPEN_TICKET: 'Edit Saved Items on an Open Ticket',
  RECALL_CLOSED_TICKET: 'Recall Closed Ticket',
  REOPEN_CLOSED_TICKET: 'Reopen Closed Ticket',
  NON_TAX_SALE: 'Non Tax Sale',
  REPRINT_KITCHEN_TICKET: 'Reprint Kitchen Ticket',
  REPRINT_CREDIT_SLIP: 'Reprint Credit Slip',
  ACCESS_ORDERS_SCREEN: 'Access Orders Screen',
  DEFER_A_SAVED_ORDER: 'Defer a Saved Order',
  BYPASS_AGE_VERIFICATION: 'Bypass Age Verification',

  CASH_MANAGEMENT_FUNCTIONS: 'Cash Management Functions',
  OPEN_CASH_DRAWER: 'Open Cash Drawer',
  OVERRIDE_REGISTER_ASSIGNMENT: 'Override Register Assignment',
  CREATE_A_PAID_IN: 'Create a Paid In',
  REGISTER_DROP: 'Register Drop',
  CLOSE_REGISTER: 'Close Register',
  VIEW_REGISTER_DETAILS: 'View Register Details',
  EDIT_BANK_DEPOSIT: 'Edit Bank Deposit',
  OVERRIDE_EOD_DEPOSIT: 'Override EOD Deposit',

  DELIVERY_FUNCTIONS: 'Delivery Functions',
  MODIFY_DISPATCHED_TICKET: 'Modify Dispatched Ticket',
  CHANGE_DRIVER_BANK_AMOUNT: 'Change Driver Bank Amount',
  ACCESS_DRIVER_STATUS_FOR_SOMEONE_ELSE: 'Access Driver Status for Someone Else',
  UNASSIGN_A_DELIVERY: 'Unassign a Delivery',
  ASSIGN_A_DELIVERY_TO_SOMEONE_ELSE: 'Assign a Delivery to Someone Else',
  PERFORM_DRIVER_DROP: 'Perform a Driver Drop',
  OVERRIDE_DELIVERY_ORDER_RESTRICTIONS: 'Override Delivery Order Restrictions',
  EDIT_CALCULATED_MILEAGE: 'Edit Calculated Mileage',

  MANAGER_FUNCTIONS: 'Manager Functions',
  CHANGE_PRINTER_SETTING: 'Change Printer Settings',
  REQUISITION_ITEMS_FOR_PRODUCTION: 'Requisition Items for Production',
  WASTE_MENU_ITEMS: 'Waste Menu Items',
  EXIT_POS: 'Exit Point of Sale',
  ACCESS_MANAGER_HOME_PAGE: 'Access Manager Home Page',
  UPDATE_SOFTWARE: 'Update Software',
  CHANGE_INVENTORY_PURCHASE_PRICES: 'Change Inventory Purchase Prices',
  CHANGE_INVENTORY_POSTING: 'Change Inventory Posting',
  ACCESS_TO_APPROVED_WEBSITES: 'Access To Approved Websites',
  REMOTE_ACCESS_TO_TCC: 'Remote Access to Thrive Control Center',
  EDIT_LOCATION: 'Edit Locations',
  GENERATE_INSTANT_MESSAGE: 'Generate Instant Messages',

  MANAGING_CUSTOMERS: 'Managing Customers',
  MANAGE_CUSTOMER_ACCOUNT: 'Manage Customer Account',
  ADJUST_CUSTOMER_POINTS: 'Adjust Customer Points',
  CHANGE_CUSTOMER_GROUP: 'Change Customer Group',
  CREDIT_OFFER_TO_CUSTOMER: 'Credit Offer to Customer',
  ALTER_PROMISE_TIMES: 'Alter Promise Items',

  MASTER_ADMIN_CONFIGURATION: 'Master Admin Configuration',
  SUPERUSER: 'Super User',
  ADD_LOCATION: 'Add Locations',
  LOCATION_LICENSING: 'Location Licensing',
  ADD_COMPANIES: 'Add Companies',
  EDIT_COMPANIES: 'Edit Companies',
  MANAGE_MENU_TEMPLATES: 'Manage Menu Templates',
  ISSUE_API_CREDENTIALS: 'Issue API Credentials',

  ONLINE_CONFIGURATION: 'Online Configuration',
  MODIFY_ONLINE_ORDERING_CONFIGURATION: 'Modify Online Ordering Configuration',
  SET_CUSTOM_CSS: 'Set Online Ordering Custom CSS',
  LIMITED_MANAGE_ONLINE: 'Limited Configuration Options',
  PUSH_NOTIFICATIONS: 'Push Notifications',

  POS_CONFIGURATION: 'Point of Sale Configuration',
  ACCESS_CONFIGURATION_OPTIONS: 'Access Configuration Options',
  EDIT_FULL_MENU: 'Edit Full Menu',
  MANAGE_LOCAL_ITEMS: 'Manage Local Items',
  OVERRIDE_PRICE_AND_TAX: 'Override Price and Tax',
  OVERRIDE_PRINTING_AND_KPS: 'Override Printing and KPS',
  OVERRIDE_FULL_MENU: 'Override Full Menu',
  OVERRIDE_ITEM_STATUS: 'Override Item Status',
  CONFIGURE_HARDWARE: 'Configure Hardware',
  CONFIGURE_CREDIT_CARDS: 'Configure Credit Cards',
  ASSIGN_REMOTE_STATION: 'Assign Remote Station',

  REPORTS: 'Reports',
  ACCESS_REPORTS: 'Access Reports',
  PAYROLL: 'Payroll',

  SERVER_FUNCTIONS: 'Server Functions',
  TRANSFER_OPEN_TICKET_ASSIGNED_TO_YOU: 'Transfer Open Ticket Assigned to You',
  TRANSFER_OPEN_TICKET_NOT_ASSIGNED_TO_YOU: 'Transfer Open Ticket Not Assigned to You',
  ACCESS_SERVER_BANKING_FOR_SOMEONE_ELSE: 'Access Server Banking for Someone Else',
  CHANGE_TABLE_NUMBER: 'Change Table Number',
  MODIFY_TIP: 'Modify Tip',
  COMBINE_TICKETS: 'Combine Tickets',

  VOIDING_TICKETS: 'Voiding Tickets',
  VOID_MADE_ITEMS_ON_OPEN_TICKETS: 'Void Made Items on Open Tickets',
  VOID_ITEMS_ON_CLOSED_TICKETS: 'Void Items on Closed Tickets',
  VOID_ENTIRE_TICKET: 'Void Entire Ticket',
  REFUND_CLOSED_TICKET_FROM_PRIOR_DAY: 'Refund Closed Ticket From Prior Day',
  REQUIRE_VOID_REASON: 'Require Void Reason',

  SYSTEM_CONFIGURATION: 'System Configuration',
  SECURITY_ROLES_AND_PERMISSIONS: 'Security Roles & Permissions',
  LOCATION_SETTINGS: 'Location Settings',
  INTEGRATIONS_SETUP: 'Integrations Setup'
}
